import SheetComponent from "./index";
import React, {Fragment} from "react";
import {useActionSheet, withActionSheet} from "../providers/ActionSheetProvider";
import {useNavigate} from "react-router-shim";
import { MOBCOLORS } from '../../configs/AppConfig';

class SheetStats extends SheetComponent
{
    constructor(props) {
        super(props);
    }

    onClose(){
    }

    renderContent()
    {
        const sheetContext=this.props.sheetContext
        const payload=sheetContext.getPayload()
        const render=payload?.params?.render
        if(!render || typeof render !== 'function'){
            return null
        }

        return(
            <div style={{display:"flex",flexDirection:"column",gap:10}}>

                <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",textAlign:"center",gap:0}}>
                    <span style={{fontSize:18,fontWeight:"bold",color:MOBCOLORS.blue.color}}>{payload.title}</span>
                </div>

                {render(this.props)}
            </div>
        )
    }
}

function withNavigate(Component) {
    return function WrappedComponent(props) {
        const navigate = useNavigate();
        return <Component {...props} navigate={navigate} />;
    }
}

export default withNavigate(withActionSheet(SheetStats))
